<h3 class="title configurator-title">{{ 'decking-boards.summary.title' | translate }}</h3>

<ng-casto-loader *ngIf="isLoading"></ng-casto-loader>

<ng-container *ngIf="!isLoading">
  <div class="summary-container shadow">
    <h4 class="title summary-title">{{ 'decking-boards.summary.environment' | translate }}</h4>
    <div class="summary-infos">
      <p class="info">{{ configuration.location[getPropertyNameLocalize('name')] }}</p>
    </div>
  </div>

  <div class="summary-container shadow mt-4">
    <h4 class="title summary-title">{{ 'decking-boards.summary.configuration' | translate }}</h4>
    <div class="summary-infos">
      <p class="info">
        {{ 'decking-boards.summary.to' | translate }} {{ configuration.shape[getPropertyNameLocalize('name')] }}
      </p>
      <p class="info">{{ 'decking-boards.summary.surface' | translate }} {{ configuration.resume.surface }} m²</p>
      <p class="info">{{ configuration.layingType[getPropertyNameLocalize('name')] }}</p>
      <p class="info">{{ 'decking-boards.summary.joistGap' | translate }} {{ configuration.resume.joistGap }} cm</p>
    </div>
  </div>

  <div class="summary-container shadow mt-4" *ngFor="let categoryName of getCategories()">
    <h4 class="title summary-title">{{ categoryName }}</h4>

    <div class="summary-infos">
      <p class="info" *ngFor="let ean of getProducts(categoryName)">
        {{ ean[getPropertyNameLocalize('name')] }} : {{ ean.quantity }}
      </p>
    </div>
  </div>

  <div class="summary-container prices-container shadow mt-4">
    <div class="price-row">
      <h4 class="title summary-title">{{ 'decking-boards.summary.total-without-vat' | translate }} :</h4>
      <p class="info">{{ configuration.resume.totalHT | number: '1.2-2' : 'fr' }} €</p>
    </div>
    <div class="price-row">
      <h4 class="title summary-title">
        {{ 'decking-boards.summary.vat-total' | translate }} ({{ configuration.resume.percentTVA }} %) :
      </h4>
      <p class="info">{{ configuration.resume.totalTVA | number: '1.2-2' : 'fr' }} €</p>
    </div>
    <div class="price-row principale">
      <h4 class="title summary-title">{{ 'decking-boards.summary.total-with-vat' | translate }} :</h4>
      <p class="info">{{ configuration.resume.totalPV | number: '1.2-2' : 'fr' }} €</p>
    </div>
  </div>
</ng-container>
